// extracted by mini-css-extract-plugin
export default {"otherContainer":"style_otherContainer__DPOkF","firstRow":"style_firstRow__Jco2z","secondRow":"style_secondRow__Ho2mt","TooltipOnro":"style_TooltipOnro__5Zzn9"};